__turbopack_context__.v({
  "className": "beretta_8e3455f-module__iP2mxq__className",
  "variable": "beretta_8e3455f-module__iP2mxq__variable",
});
